import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchPendingApprovals = createAsyncThunk(
    "fetchPendingApprovals",
    async ({ page, limit, filters } = {}) => {
        const params = new URLSearchParams({
            page: page || 1,
            limit: limit || 50,
            distributorCode: filters?.distributorCode || "",
            dateFrom: filters?.dateFrom || "",
            dateTo: filters?.dateTo || "",
        });
        const response = await axiosHttp.get(`replenishment/overrides/pending-approvals?${params}`);
        return response.data;
    }
);

export const approveOverride = createAsyncThunk(
    "approveOverride",
    async ({ overrideId, approvedBy, note }, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.post(`replenishment/overrides/${overrideId}/approve`, {
                approvedBy,
                note: note || "",
            });
            return response.data;
        } catch (err) {
            const apiMessage = err?.response?.data?.message || err?.response?.data?.error || err.message;
            return rejectWithValue({ message: apiMessage });
        }
    }
);

export const rejectOverride = createAsyncThunk(
    "rejectOverride",
    async ({ overrideId, rejectedBy, note }, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.post(`replenishment/overrides/${overrideId}/reject`, {
                rejectedBy,
                note,
            });
            return response.data;
        } catch (err) {
            const apiMessage = err?.response?.data?.message || err?.response?.data?.error || err.message;
            return rejectWithValue({ message: apiMessage });
        }
    }
);

const PendingApprovalsSlice = createSlice({
    name: "PendingApprovalsSlice",
    initialState: {
        isLoading: false,
        data: [],
        error: null,
        total: 0,
        page: 1,
        limit: 50,
        isActionLoading: false,
    },

    extraReducers: (builder) => {
        // Fetch list
        builder.addCase(fetchPendingApprovals.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        });
        builder.addCase(fetchPendingApprovals.fulfilled, (state, action) => {
            state.isLoading = false;
            // API shape: { status, data: { data: [...], total, limit, offset } }
            const inner = action.payload?.data;
            state.data = Array.isArray(inner?.data) ? inner.data : [];
            state.total = inner?.total ?? 0;
            state.page = action.meta.arg?.page || 1;
        });
        builder.addCase(fetchPendingApprovals.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error?.message;
        });

        // Approve
        builder.addCase(approveOverride.pending, (state) => {
            state.isActionLoading = true;
        });
        builder.addCase(approveOverride.fulfilled, (state) => {
            state.isActionLoading = false;
        });
        builder.addCase(approveOverride.rejected, (state, action) => {
            state.isActionLoading = false;
            state.error = action.payload?.message || action.error?.message;
        });

        // Reject
        builder.addCase(rejectOverride.pending, (state) => {
            state.isActionLoading = true;
        });
        builder.addCase(rejectOverride.fulfilled, (state) => {
            state.isActionLoading = false;
        });
        builder.addCase(rejectOverride.rejected, (state, action) => {
            state.isActionLoading = false;
            state.error = action.payload?.message || action.error?.message;
        });
    },
});

export default PendingApprovalsSlice.reducer;
